import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GlobalService } from './global-service.service';

export enum IdleUserTimes {
  IdleTime = 1000*60*60,
  CountdownTime = 1000*120
  /*
  IdleTime = 1000*60,
  CountdownTime = 1000*30
  */
}

@Injectable({
  providedIn: 'root'
})
export class IdleUserService {
  private timeoutId: any;
  private countdownId: any;
  private countdownValue: number;
  private toastrID=-1;
  private lastReset=-1;

  userInactive: Subject<boolean> = new Subject();

  constructor(private toastr: ToastrService, private globserv: GlobalService, ) {
  	 this.lastReset=Date.now();
    this.reset();
    this.initListener();
    this.toastr.toastrConfig.preventDuplicates = true;
  }

  initListener() 
  {  	
    window.addEventListener('mousemove', () => this.reset());
    window.addEventListener('click', () => this.reset());
    window.addEventListener('keypress', () => this.reset());
    window.addEventListener('DOMMouseScroll', () => this.reset());
    window.addEventListener('mousewheel', () => this.reset());
    window.addEventListener('touchmove', () => this.reset());
    window.addEventListener('MSPointerMove', () => this.reset());
  }
  
  
  reset() {
    clearTimeout(this.timeoutId);
    clearTimeout(this.countdownId);
    
    if (Date.now()-this.lastReset>IdleUserTimes.IdleTime )
    {
    		this.globserv.setLogOut();
    }
    
    this.lastReset=Date.now();

	 if (this.toastrID>-1)
	 {
	 	this.toastr.remove( this.toastrID);
	 	this.toastrID=-1;
	 }    
    
    if (this.globserv.Login.LoginStatus)
    {
    	this.startIdleTimer();
    }
  }

  startIdleTimer() {
    this.timeoutId = setTimeout(() => {
      console.log('Inactivity detected');
      this.startCountdown();
    }, IdleUserTimes.IdleTime);
  }

  startCountdown() {
  	
  	 var activeToastr=this.toastr.warning("Du scheinst aktuell nicht mehr mit Pasura zu arbeiten,  zur Sicherheit wirst Du daher in 2 Minuten automatisch ausgeloggt.", "Auto-Logout", { timeOut:IdleUserTimes.CountdownTime, progressBar:true, positionClass: "toast-top-right"});
  	 console.log("tstID=" + JSON.stringify(activeToastr.toastId));
  	 this.toastrID=activeToastr.toastId;
  	 
    this.countdownValue = IdleUserTimes.CountdownTime / 1000;
    this.countdownId = setInterval(() => {
      this.countdownValue--;
      console.log('You will logout in:', this.countdownValue, 'seconds');
      if (this.countdownValue <= 0) {
        clearInterval(this.countdownId);
        console.log('User idle');
        this.userInactive.next(true);
      }
    }, 1000);
  }
}